import $http from '@/plugins/axios'
import * as querystring from 'querystring'

export const DebuggerService = {
    chatHistory (botCode, query) {
        const queryParams = unescape(querystring.stringify(query))
        return $http.get(`debugger/${botCode}/chat-history?${queryParams}`)
    },
    debugData (botCode, requestId) {
        return $http.get(`debugger/${botCode}/detail/${requestId}?`)
    }
}
export default DebuggerService
